import {Component} from "react";
import {Modal} from "react-bootstrap";
import LoginFields from '../LoginFields/LoginFields';
import React from "react";
import { withRouter } from 'react-router-dom';
import './HomeHeader.css';
import {connect} from "react-redux";

var logo = require('../assets/images/logo_avenuepm.png');

class Header extends Component {
    constructor(props) {
        super(props);
        this.state = {
            currentItem: null,
            isLogin: false
        };

        this.handleLogin = this.handleLogin.bind(this);
        this.closeLogin = this.closeLogin.bind(this);
        this.handleHome = this.handleHome.bind(this);
        this.handleResources = this.handleResources.bind(this);
        this.handleRequestAccount = this.handleRequestAccount.bind(this);
        this.handleHelp = this.handleHelp.bind(this);
    }

    componentDidMount() {
        this.setState({currentItem: this.props.currentItem});
    }

    handleLogin(){
        this.setState({isLogin: true});
    }

    handleHome(){
        this.props.history.push("/login");
    }

    handleResources(){
        this.props.history.push("/resources");
    }

    handleRequestAccount(){
        this.props.history.push("/request-account");
    }

    handleHelp(){
        this.props.history.push("/help");
    }

    closeLogin(){
        this.setState({isLogin: false});
    }

    render() {
        return (
            <nav id="header" className="navbar">
                <div id="header-container" className="container navbar-container">
                    <a id="brand" className="navbar-brand" href="/login"><img src={logo} alt="AvenuePM" border="0" style={{marginTop:-15}}/></a>
                    <ul id= "headerBox" className="nav navbar-nav pull-right">
                        <li class="headerItem" onClick={this.handleHome} ><a className={this.props.currentItem === 'Home' ? "handBtn active" : "handBtn"}><span>Home</span></a></li>
                        <li class="headerItem" onClick={this.handleRequestAccount} ><a className={this.props.currentItem === 'RequestAccount' ? "handBtn active" : "handBtn"}><span>Request a Teacher Account</span></a></li>
                        <li class="headerItem" onClick={this.handleHelp} ><a className={this.props.currentItem === 'Help' ? "handBtn active" : "handBtn"}><span>Help!</span></a></li>

                    </ul>
                </div>
                <Modal id="loginModal" show={this.state.isLogin} >
                    <LoginFields callbackFromParent={this.setUser} closeLogin = {this.closeLogin}/>
                </Modal>
            </nav>

        );
    }
}
export default withRouter(Header);